<template>
  <v-dialog v-model="sickDialog" width="1024" @click:outside="closeDialog">
    <v-card>
      <v-card-title class="text-h5 grey lighten-2 justify-space-between align-center">
          {{sickEmployee.name}}
          <v-btn icon @click="closeDialog"><v-icon>mdi-close</v-icon></v-btn>
      </v-card-title>
      <v-card-text class="py-5">
        <div v-if="loading" class="d-flex justify-center">
          <v-progress-circular
            :size="30"
            :width="2"
            color="primary"
            indeterminate
          />
        </div>
        <template v-else>
          <v-row v-if="sicknessEpisodes && sicknessEpisodes.length">
            <v-col cols="4">
              <v-card v-for="card in sicknessEpisodes" elevation="2" :key="card.id" :style="[{opacity: card.isClosed ? 1 : 0.5}]" color="grey lighten-3" class="pa-3 mb-4">
                <div class="text-center mb-2">
                  <strong>{{card.startDate !== card.endDate ? `${Date.getFormatDateStr(card.startDate)} - ${Date.getFormatDateStr(card.endDate)}` : Date.getFormatDateStr(card.startDate)}}</strong>
                </div>
                <div v-if="card.attachments && card.attachments.length" class="d-flex flex-wrap">
                  <v-chip :ripple="false" v-for="attachment in card.attachments" :key="attachment.id" label class="mr-1 mb-1" @click="setAttachment(attachment)" :color="attachment.id === chosenAttachment.id ? 'grey lighten-1' : 'grey lighten-2'">{{attachment.originalName}}</v-chip>
                </div>
                <div v-else class="mb-1"><i><strong class="grey--text">No Files</strong></i></div>
                <div v-if="card.workingDays && card.workingDays.length">
                  <strong class="d-block">Working days during sickness</strong>
                  <v-row>
                    <v-col cols="5"></v-col>
                    <v-col cols="3"><strong>am</strong></v-col>
                    <v-col cols="3"><strong>pm</strong></v-col>
                  </v-row>
                  <div v-for="(day, index) in card.uniqDates" :key="day.date + index">
                    <v-row class="align-center">
                      <v-col cols="5" class="py-1">
                        {{Date.getFormatDateStr(day.date)}}
                      </v-col>
                      <v-col cols="3" class="py-1"><v-icon v-if="day.am" size="20">mdi-check</v-icon></v-col>
                      <v-col cols="3" class="py-1"><v-icon v-if="day.pm" size="20">mdi-check</v-icon></v-col>
                    </v-row>
                  </div>
                </div>
                <div v-else class="grey--text"><strong><i>No working days</i></strong></div>
              </v-card>
            </v-col>
            <v-col cols="8">
              <v-card-title  class="body-1 grey lighten-3 d-flex justify-space-between">
                {{chosenAttachment.originalName || 'No selected file'}}
                <v-btn color="primary" :disabled="!chosenAttachment.id" @click="downloadFile">download</v-btn>
              </v-card-title>
              <SimpleFilePreview v-if="chosenAttachment.downloadLink" :fileData="chosenAttachment"/>
              <div v-else class="text-center py-12">
                <v-icon size="50" color="grey lighten-1">mdi-file-document</v-icon>
              </div>
            </v-col>
          </v-row>
          <div v-else class="text-center py-1">No data available</div>
        </template>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
  import { mapActions } from 'vuex'
  import SimpleFilePreview from '@/views/accounting/SimpleFilePreview'
  import { downloadBlob } from '@/common/functions'

  export default {
    name: 'SickDialog',
    components: { SimpleFilePreview },
    props: ['sickDialog', 'sickEmployee'],

    data: () => ({
      loading: false,
      sicknessEpisodes: [],
      chosenAttachment: {}
    }),

    mounted: async function () {
      try {
        const queryData = {
          EmployeeId: this.sickEmployee.employeeId,
          Date: this.sickEmployee.date
        }
        this.loading = true
        const sicknessData = await this.fetchSickness(queryData)
        const localEpisodes = [...sicknessData.data.sicknessEpisodes]
        localEpisodes.forEach(episodeItem => {
          const localUniqDates = []
          episodeItem.workingDays.forEach(dayItem => {
            const localDayItem = {}
            const checkExist = localUniqDates.findIndex(uniqDate => uniqDate.date === dayItem.date)
            if (checkExist === -1) {
              localDayItem.date = dayItem.date
              episodeItem.workingDays.filter(filterItem => filterItem.date === dayItem.date).forEach(designatorItem => {
                if (designatorItem.designator === 'PM') {
                  localDayItem.pm = true
                }
                if (designatorItem.designator === 'AM') {
                  localDayItem.am = true
                }
              })
              localUniqDates.push(localDayItem)
            }
          })
          localUniqDates.sort(this.compare)
          episodeItem.uniqDates = localUniqDates
        })
        this.sicknessEpisodes = sicknessData.data.sicknessEpisodes
        setTimeout(() => {
          this.loading = false
        }, 500)
      } catch (e) {
        this.loading = false
      }
    },

    methods: {
      ...mapActions(['fetchSickness']),
      closeDialog: function () {
        this.$emit('closeDialog')
      },
      compare: function (a, b) {
        if (a.date < b.date) {
          return -1
        }
        if (a.date > b.date) {
          return 1
        }
        return 0
      },
      setAttachment: function (data) {
        this.chosenAttachment = data
      },
      downloadFile: function () {
        downloadBlob(this.chosenAttachment.downloadLink)
      }
    }
  }
</script>
